export default "__VITE_ASSET__UWh$VNEm__"